/**
 * Reine Berechnungsfunktionen für Solarenergie.
 * Kein State, keine Seiteneffekte — nur Mathematik.
 */

import type { SolarEnergyConfig } from '../config/SolarEnergyConfig';

/** Distanz-Faktor aus orbital_ring. Gibt 0 für ungültige Ringe. */
export function distanceFactor(orbitalRing: number, config: SolarEnergyConfig): number {
  if (orbitalRing < 0 || orbitalRing >= config.distanceFactors.length) return 0;
  return config.distanceFactors[orbitalRing];
}

/**
 * Alters-Faktor der Sonne.
 * age 0.0 (jung) → 1.0, age 1.0 (kurz vor Tod) → 1.0 + steps × boost.
 * Steigt in diskreten Stufen: alle 10% Lebensdauer +5%.
 */
export function ageFactor(sunAge: number, config: SolarEnergyConfig): number {
  const clamped = Math.max(0, Math.min(sunAge, 1));
  const step = Math.floor(clamped * config.ageSteps);
  return 1 + step * config.ageBoostPerStep;
}

/**
 * Berechnet die Solarenergie eines Planeten.
 * Gibt 0 zurück wenn die Sonne nicht lebt.
 */
export function calcSolarEnergy(
  orbitalRing: number,
  sunAge: number,
  luminosity: number,
  sunAlive: boolean,
  config: SolarEnergyConfig,
): number {
  if (!sunAlive) return 0;
  return config.baseEnergy * luminosity * distanceFactor(orbitalRing, config) * ageFactor(sunAge, config);
}
